import { render, staticRenderFns } from "./ChatRoomCenter.vue?vue&type=template&id=3d137229&scoped=true&"
import script from "./ChatRoomCenter.vue?vue&type=script&lang=js&"
export * from "./ChatRoomCenter.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomCenter.vue?vue&type=style&index=0&id=3d137229&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d137229",
  null
  
)

export default component.exports